// Central data for company info, services, stats
export const COMPANY = {
  name: "SHREE AMBEY",
  suffix: "ROADLINES",
  tagline: "Moving India's Payload with Precision.",
  subtagline:
    "Government & Private Transport solutions across the nation. Based in Kanpur, delivering everywhere.",
  address: {
    line1: "133/271, Transport Nagar",
    line2: "Kanpur, Uttar Pradesh, India",
  },
  owners: [
    {
      name: "Akhilesh Shukla",
      phone: "9336116860",
      waCountry: "91",
      role: "Founder & Managing Partner",
      photo:
        "https://customer-assets.emergentagent.com/job_roadlines-logistics-3/artifacts/cu9qfbxp_IMG-20260702-WA0000.jpg",
    },
    {
      name: "Aviral Shukla",
      phone: "8052121211",
      waCountry: "91",
      role: "Partner & Operations Head",
      photo:
        "https://customer-assets.emergentagent.com/job_roadlines-logistics-3/artifacts/xgq856u1_IMG-20260702-WA0001.jpg",
    },
  ],
  founded: "Est. Kanpur",
  mapEmbed:
    "https://www.google.com/maps?q=Transport+Nagar,+Kanpur,+Uttar+Pradesh&output=embed",
  mapLink:
    "https://www.google.com/maps/search/?api=1&query=Transport+Nagar+Kanpur",
};

export const waLink = (owner, msg = "Hello, I would like a quote from Shree Ambey Roadlines.") =>
  `https://wa.me/${owner.waCountry}${owner.phone}?text=${encodeURIComponent(msg)}`;

export const STATS = [
  { value: "28+", label: "Indian States Served" },
  { value: "100K+", label: "Tonnes Delivered" },
  { value: "24/7", label: "Dispatch Support" },
  { value: "Pan-India", label: "Coverage Network" },
];

export const SERVICES = [
  {
    key: "govt",
    title: "Government Payload",
    description:
      "Trusted movement of tender-based government consignments with full compliance, documentation and time-bound delivery.",
    icon: "Buildings",
  },
  {
    key: "private",
    title: "Private Transport",
    description:
      "Bulk industrial and commercial shipments handled with dedicated fleet, priority routing and real-time coordination.",
    icon: "Package",
  },
  {
    key: "pan",
    title: "Pan-India Delivery",
    description:
      "Point-to-point road transport reaching every state, from metros to remote industrial towns across India.",
    icon: "MapPinLine",
  },
  {
    key: "ftl",
    title: "Full Truck Load (FTL)",
    description:
      "Direct FTL movement with heavy-duty trucks, tarpaulin protection and secure loading for oversized cargo.",
    icon: "Truck",
  },
  {
    key: "warehouse",
    title: "Warehousing",
    description:
      "Short and long-term warehousing at Transport Nagar Kanpur with inventory handling and cross-docking.",
    icon: "Warehouse",
  },
];

export const PAYLOAD_TYPES = [
  "Government Consignment",
  "Industrial Machinery",
  "Steel & Metals",
  "FMCG / Retail",
  "Agricultural Produce",
  "Construction Material",
  "Full Truck Load",
  "Other",
];

export const MEDIA = {
  hero: "https://static.prod-images.emergentagent.com/jobs/0bc7b285-7ea0-4dd5-83c9-6d2abbfda76c/images/8b768128f284e6b0489796f68f2e9571272e8806c1e18bb2dad90ed2114b599c.png",
  aboutTruck:
    "https://static.prod-images.emergentagent.com/jobs/0bc7b285-7ea0-4dd5-83c9-6d2abbfda76c/images/35abd44d2b37105fd11a9ac1939a99d227b477714f741838de6777550f8af849.png",
  fleet:
    "https://static.prod-images.emergentagent.com/jobs/0bc7b285-7ea0-4dd5-83c9-6d2abbfda76c/images/e93d31cc7504a9a48a1d363ce65d71d70780be2f826ef6e5d91fc46744308ac5.png",
  warehouse:
    "https://images.pexels.com/photos/4487383/pexels-photo-4487383.jpeg",
  payload:
    "https://static.prod-images.emergentagent.com/jobs/0bc7b285-7ea0-4dd5-83c9-6d2abbfda76c/images/e664870f602e66be2dce8363a086aafbf2586551615a6ec0424dee030faa4c8e.png",
};

export const CLIENTS = [
  "Bharat Steel Corp.",
  "UP Agro Federation",
  "Kanpur Cement Works",
  "North Rail Depot",
  "Ganga Textiles",
  "Delhi FMCG Hub",
  "Lucknow Machinery Co.",
  "Indo-Metal Industries",
];

export const TESTIMONIALS = [
  {
    quote:
      "Shree Ambey handled our multi-state government tender consignment without a single delay. Documentation was spotless.",
    name: "Rajeev Verma",
    role: "Procurement Head, Public Works Dept.",
  },
  {
    quote:
      "For three years they have moved our steel coils Kanpur to Mumbai every month. Their fleet and drivers are reliable.",
    name: "Sunita Agarwal",
    role: "Logistics Manager, Bharat Steel Corp.",
  },
  {
    quote:
      "Akhilesh ji picks up the phone at 2 AM if a truck needs re-routing. That's the kind of partner you want on Indian highways.",
    name: "Mohit Khanna",
    role: "Owner, Ganga Textiles",
  },
];
